"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// These are production canonical URLs
var URLS;
(function (URLS) {
    URLS["ROOT"] = "https://www.deviantart.com";
    // the following are non-node URLs
    URLS["ABOUT"] = "https://about.deviantart.com";
    URLS["ADVERTISE"] = "https://about.deviantart.com/advertising";
    URLS["CAREERS"] = "https://deviantart.theresumator.com/apply/";
    URLS["CART"] = "https://www.deviantart.com/checkout/";
    URLS["COMMISSIONS"] = "https://www.deviantart.com/commissions";
    URLS["CONTACT"] = "https://www.deviantartsupport.com/en/article/how-do-i-contact-deviantart";
    URLS["COPYRIGHT"] = "https://about.deviantart.com/policy/copyright/";
    URLS["CORE_MEMBERSHIP"] = "https://www.deviantart.com/core-membership";
    URLS["DEVELOPERS"] = "https://www.deviantart.com/developers";
    URLS["EARNINGS"] = "https://www.deviantart.com/account/earnings/";
    URLS["ETIQUETTE"] = "https://about.deviantart.com/policy/etiquette";
    URLS["FEEDBACK"] = "https://www.deviantartsupport.com/en/eclipse";
    URLS["FORUM"] = "https://forum.deviantart.com";
    URLS["GROUPS"] = "https://groups.deviantart.com";
    URLS["HELP"] = "https://www.deviantartsupport.com/en/";
    URLS["LOGOUT"] = "https://www.deviantart.com/users/logout";
    URLS["MLT"] = "https://www.deviantart.com/morelikethis";
    URLS["NOTES"] = "https://www.deviantart.com/notifications/notes";
    URLS["ORDERS"] = "https://www.deviantart.com/account/";
    URLS["POINTS"] = "https://www.deviantart.com/account/points/";
    URLS["POLLS"] = "https://www.deviantart.com/polls";
    URLS["PRIVACY"] = "https://about.deviantart.com/policy/privacy";
    URLS["SETTINGS"] = "https://www.deviantart.com/settings/identity";
    URLS["SETTINGS_GENERAL"] = "https://www.deviantart.com/settings/general";
    URLS["SHOP"] = "https://shop.deviantart.com";
    URLS["STASH"] = "https://sta.sh/";
    URLS["STATUS_UPDATES"] = "https://www.deviantart.com/status-updates";
    URLS["SUBMIT"] = "https://www.deviantart.com/submit";
    URLS["SUBMIT_MOTIONBOOK"] = "https://social.madefire.com/da-signin/";
    URLS["SUBMIT_MURO"] = "https://sta.sh/muro";
    URLS["TAG"] = "https://www.deviantart.com/tag";
    URLS["TOS"] = "https://about.deviantart.com/policy/service";
    URLS["WATCHING"] = "https://www.deviantart.com/watching/";
})(URLS = exports.URLS || (exports.URLS = {}));
var PROJECTS;
(function (PROJECTS) {
    PROJECTS["BROWSE"] = "BROWSE";
    PROJECTS["MESSAGECENTRE"] = "MESSAGECENTRE";
    PROJECTS["PROFILE"] = "PROFILE";
    PROJECTS["DEVIATION"] = "DEVIATION";
    PROJECTS["COMMENTS"] = "COMMENTS";
    PROJECTS["SISU"] = "SISU";
})(PROJECTS = exports.PROJECTS || (exports.PROJECTS = {}));
var USER_PROFILE_SECTION_PATHS;
(function (USER_PROFILE_SECTION_PATHS) {
    USER_PROFILE_SECTION_PATHS["HOME"] = "";
    USER_PROFILE_SECTION_PATHS["ABOUT"] = "about";
    USER_PROFILE_SECTION_PATHS["GALLERY"] = "gallery";
    USER_PROFILE_SECTION_PATHS["SHOP"] = "shop";
    USER_PROFILE_SECTION_PATHS["FAVOURITES"] = "favourites";
    USER_PROFILE_SECTION_PATHS["POSTS"] = "posts";
})(USER_PROFILE_SECTION_PATHS = exports.USER_PROFILE_SECTION_PATHS || (exports.USER_PROFILE_SECTION_PATHS = {}));
var USER_PROFILE_SHOP_SUB_PATHS;
(function (USER_PROFILE_SHOP_SUB_PATHS) {
    USER_PROFILE_SHOP_SUB_PATHS["ALL"] = "";
    USER_PROFILE_SHOP_SUB_PATHS["COMMISSIONS"] = "commissions";
    USER_PROFILE_SHOP_SUB_PATHS["PRINTS"] = "prints";
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_CONTENT"] = "premium_content";
})(USER_PROFILE_SHOP_SUB_PATHS = exports.USER_PROFILE_SHOP_SUB_PATHS || (exports.USER_PROFILE_SHOP_SUB_PATHS = {}));
var USER_PROFILE_POSTS_SUB_PATHS;
(function (USER_PROFILE_POSTS_SUB_PATHS) {
    USER_PROFILE_POSTS_SUB_PATHS["ALL"] = "";
    USER_PROFILE_POSTS_SUB_PATHS["JOURNALS"] = "journals";
    USER_PROFILE_POSTS_SUB_PATHS["STATUSES"] = "statuses";
    USER_PROFILE_POSTS_SUB_PATHS["POLLS"] = "polls";
    USER_PROFILE_POSTS_SUB_PATHS["DRAFTS"] = "drafts";
})(USER_PROFILE_POSTS_SUB_PATHS = exports.USER_PROFILE_POSTS_SUB_PATHS || (exports.USER_PROFILE_POSTS_SUB_PATHS = {}));
var DEVIATION_PATHS;
(function (DEVIATION_PATHS) {
    DEVIATION_PATHS["DEVIATION"] = "art";
    DEVIATION_PATHS["JOURNAL"] = "journal";
    DEVIATION_PATHS["COMMISSION"] = "commission";
    DEVIATION_PATHS["STATUS"] = "status-update";
    DEVIATION_PATHS["POLL"] = "poll";
})(DEVIATION_PATHS = exports.DEVIATION_PATHS || (exports.DEVIATION_PATHS = {}));
//# sourceMappingURL=constants.js.map